import { TimerOffIcon } from './TimerOffIcon';

/**
 * author: Michael Irigoyen
 * id CC698648-1A71-4EC8-A1E3-B5ACC42F2FDB
 * name timer-off
 * version: 5.0.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-off.svg
 * tags
 * - Date / Time 
 */
export const StopwatchOffIcon = TimerOffIcon;
export default StopwatchOffIcon